import React from "react";

function StockFooter() {
  return (
    <React.Fragment>
      <footer>
        <div>
          <div>
            <h1>FIRSTOCK</h1>
            <p>
              A success formula for right investing may not exist. But a simple
              formula for investing sure does.
            </p>
          </div>
          <ul>
            <li>Getting Started</li>
            <li>Bank Transfer</li>
            <li>Refferal</li>
            <li>Downloads and Forms</li>
            <li>My Reports and Profile</li>
          </ul>
          <ul>
            <li>Disclaimer</li>
            <li>Policy and Procedure</li>
            <li>Privacy Policy</li>
            <li>Term and Conditions</li>
            <li>Holiday Calender</li>
          </ul>
        </div>
        <div>Copyright 2021 FIRSTOCK | All Rights Reserved</div>
      </footer>
    </React.Fragment>
  );
}

export default StockFooter;
